import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, styled, Typography } from "@mui/material";
import { isNotUndefinedOrNull } from "../../FunctionsCore";
import { ForwardArrow } from "../../icons/forward";
import { Container, RowStyle } from "../../theme/common";
import { FONTSTYPO, SPACING } from "../../theme/palette";
import { ContainerLargeStyleWhite, SectionBlueHeadingTextStyle } from "../Styles";
const CardStyle = styled("div")(({ theme }) => ({
    "alignItems": " flex-start",
    "backgroundColor": theme.palette.primary.dark,
    "borderRadius": FONTSTYPO.step0,
    "color": theme.palette.common.white,
    "display": "flex",
    "flexDirection": "column",
    "gap": SPACING.spaces,
    "height": "fit-content",
    "padding": SPACING.spacesL,
    "textAlign": "left"
}));
const TagRowStyle = styled("div")(() => ({
    "alignItems": "center",
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "5px",
    "marginBlockStart": SPACING.spaces,
    "textTransform": "uppercase"
}));
const TagTitleStyle = styled("div")(({ theme }) => (Object.assign({}, theme.typography.h6)));
const TagStyle = styled("div")(({ theme }) => ({
    "background": theme.palette.secondary.light,
    "borderRadius": "4px",
    "color": theme.palette.secondary.main,
    "padding": "0.2em 0.6em 0.3em",
    "paddingInline": SPACING.spacem
}));
export const GetADemoComponent = (props) => {
    const { buttonLink, buttonText, description, heading, subheading, tagTitle, tags } = props;
    return (_jsx(ContainerLargeStyleWhite, { children: _jsxs(Container, { children: [_jsxs(RowStyle, { children: [_jsx("div", Object.assign({ style: { "flexGrow": 3 } }, { children: isNotUndefinedOrNull(description) ? (_jsx(SectionBlueHeadingTextStyle, { children: _jsx("div", { dangerouslySetInnerHTML: { "__html": description } }) })) : (_jsx(_Fragment, { children: " " })) })), _jsxs(CardStyle, { children: [isNotUndefinedOrNull(heading) ? (_jsx(Typography, Object.assign({ variant: "h4" }, { children: heading }))) : (_jsx(_Fragment, {})), isNotUndefinedOrNull(subheading) ? (_jsx(Typography, Object.assign({ variant: "h6" }, { children: subheading }))) : (_jsx(_Fragment, {})), isNotUndefinedOrNull(buttonText) && isNotUndefinedOrNull(buttonLink) ? (_jsxs(Button, Object.assign({ color: "inherit", href: buttonLink, size: "medium", variant: "outlined" }, { children: [buttonText, " ", _jsx(ForwardArrow, { width: "14px" })] }))) : (_jsx(_Fragment, {}))] })] }), isNotUndefinedOrNull(tags) ? (_jsxs(TagRowStyle, { children: [_jsx(TagTitleStyle, { children: tagTitle }), tags.map((res, index) => (_jsx(TagStyle, { children: res }, index)))] })) : (_jsx(_Fragment, {}))] }) }));
};
